import { FocusedFeatureTypes } from 'common/types'
import { VideoColumns } from 'room/group-room/presentation/video-columns'
import ThreeColumnsVideoGrid from 'room/training-room/ice-breaker/presentation/three-columns-video-grid'
import { SceneVideoUser } from 'video-conference-media'
import OnlyAudioGrid from 'video-conference-media/presentation/only-audio-grid'
import { PresenterStyle } from 'video-conference-media/presentation/presenter-grid-layout'
import { VideoGrid } from 'video-conference-media/presentation/video-grid'
import { VideoLayoutKnowledgeCheckResolver } from './video-layout-knowledge-check-resolver'

type VideoGridResolverProps = {
	focusedFeature: FocusedFeatureTypes
	streams: Array<SceneVideoUser>
	presenterStyle: PresenterStyle
}

export const VideoLayoutResolver: React.FC<VideoGridResolverProps> = ({
	focusedFeature,
	streams,
	presenterStyle,
	children,
}) => {
	const layout = getFeatureLayout(focusedFeature)

	switch (layout) {
		case 'KNOWLEDGE_CHECK_THREE_COLUMNS_GRID':
			return (
				<VideoLayoutKnowledgeCheckResolver streams={streams}>
					{children}
				</VideoLayoutKnowledgeCheckResolver>
			)
		case 'THREE_COLUMNS_GRID':
			return (
				<ThreeColumnsVideoGrid sceneVideoUsers={streams}>
					{children}
				</ThreeColumnsVideoGrid>
			)
		case 'COLUMNS_GRID':
			return <VideoColumns sceneVideoUsers={streams}>{children}</VideoColumns>
		case 'AUDIO_ONLY':
			return <OnlyAudioGrid sceneVideoUsers={streams}>{children}</OnlyAudioGrid>
		case 'DEFAULT_LAYOUT':
			return (
				<VideoGrid sceneVideoUsers={streams} presenterStyle={presenterStyle}>
					{children}
				</VideoGrid>
			)
		case 'NOT_IMPLEMENTED':
			return <>{children}</>
		default:
			return (
				<VideoGrid sceneVideoUsers={streams} presenterStyle={presenterStyle}>
					{children}
				</VideoGrid>
			)
	}
}

type FeatureLayoutType =
	| 'THREE_COLUMNS_GRID'
	| 'KNOWLEDGE_CHECK_THREE_COLUMNS_GRID'
	| 'COLUMNS_GRID'
	| 'AUDIO_ONLY'
	| 'DEFAULT_LAYOUT'
	| 'NOT_IMPLEMENTED'

const getFeatureLayout = (type: FocusedFeatureTypes): FeatureLayoutType => {
	switch (type) {
		case FocusedFeatureTypes.KNOWLEDGE_CHECK:
			return 'KNOWLEDGE_CHECK_THREE_COLUMNS_GRID'
		case FocusedFeatureTypes.ICEBREAKER:
		case FocusedFeatureTypes.SLIDE:
			return 'THREE_COLUMNS_GRID'
		case FocusedFeatureTypes.ScreenShare:
		case FocusedFeatureTypes.WHITEBOARD:
		case FocusedFeatureTypes.SIMPLE_GROUPING:
		case FocusedFeatureTypes.POLLING_MULTIPLE_CHOICE:
		case FocusedFeatureTypes.POLLING_OPEN_ENDED_WORD_CLOUD:
		case FocusedFeatureTypes.POLLING_OPEN_ENDED_LIST:
		case FocusedFeatureTypes.NOTEPAD:
		case FocusedFeatureTypes.AUDIO_STREAMING:
		case FocusedFeatureTypes.YOUTUBE_STREAMING:
		case FocusedFeatureTypes.GROUPING:
			return 'NOT_IMPLEMENTED'
		default:
			return 'DEFAULT_LAYOUT'
	}
}
